import styled from 'styled-components';

import {
	getPrimaryTextColor,
	getSecondaryTextColor,
	getTextInputBackgroundColor,
	getTextInputBorderColor,
} from '../../themes/themeSelector';

export const LabelWrapper = styled.div<{ kind: string; $isSmallScreen?: boolean }>`
	display: flex;
	justify-content: space-between;

	label {
		font-size: ${({ $isSmallScreen }) => ($isSmallScreen ? '14px' : '16px')};
		margin-bottom: ${({ $isSmallScreen }) => ($isSmallScreen ? '5px' : '7px')};
		display: block;
		color: ${({ theme, kind }) => getSecondaryTextColor(theme, kind)};
		user-select: none;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
`;

export const Input = styled.input<{
	kind: string;
	$isSmallScreen?: boolean;
	buttonPadding?: React.CSSProperties['padding'];
	$editable?: boolean;
}>`
	display: block;
	position: relative;
	width: 100%;
	height: ${({ $isSmallScreen }) => ($isSmallScreen ? '40px' : '50px')};
	padding: ${({ $isSmallScreen }) => ($isSmallScreen ? '10px' : '10px 18px')};
	padding-right: calc(${({ buttonPadding }) => buttonPadding} + 0.5rem);
	border-radius: 4px;
	font-size: ${({ $isSmallScreen }) => ($isSmallScreen ? '14px' : '18px')};
	color: ${({ theme, kind, $editable = true }) => ($editable ? getPrimaryTextColor(theme, kind) : theme.colors.greyR)};
	background-color: ${({ theme, kind }) => getTextInputBackgroundColor(theme, kind)};
	font-family: Barlow, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
		'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
	text-align: left;
	border: 2px solid ${({ theme, kind }) => getTextInputBorderColor(theme, kind)};

	&.error {
		border: 2px solid ${({ theme }) => theme.colors.danger};
	}

	&:focus {
		outline: none;
	}

	::placeholder {
		color: ${({ theme }) => theme.colors.greyR};
	}
`;

export const RightButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: 0.5rem;
	top: 0.5rem;
	bottom: 0.5rem;
	transition: 100ms opacity ease;

	&:hover {
		opacity: 1;
	}

	&:active {
		opacity: 0.7;
	}
`;

export const AutoCompleteWrapper = styled.ul<{ kind: string }>`
	position: absolute;
	width: 100%;
	border-radius: 0.25rem;
	color: ${({ theme, kind }) => getPrimaryTextColor(theme, kind)};
	background-color: ${({ theme, kind }) => getTextInputBackgroundColor(theme, kind)};
	z-index: 1000;

	li {
		padding: 0.25rem;

		&:not(:first-child) {
			border-top: 1px solid #e2e8f0;
		}

		&:not(.neutral) {
			cursor: pointer;
			&:hover {
				background-color: #f4f4f4;
			}
		}

		&.active {
			background-color: #e4e4e4;
		}
	}
`;

// NOTE: use of this component as rightButton is encouraged, but not required.
export const TextInputButton = styled.button<{ width: React.CSSProperties['width'] }>`
	height: 100%;
	width: ${(props) => props.width};
	display: flex;
	justify-content: center;
`;
